import React, { Fragment } from "react";

const ClostJobPost = ({
  user: { avatar, companyname, firstname, lastname, location },
  setCloseJobPost,
  deleteJobPost,
  JobApplication,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => setCloseJobPost(false)}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font bold">{companyname}</span>
                </li>
                <li className="user-online-item">
                  {firstname} {lastname}
                </li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text white">
            <i className="fas fa-exclamation-circle fa-lg red mr-5"></i>Are you
            sure you would like to close this job post?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-red"
              onClick={() => {
                deleteJobPost(JobApplication);
                setCloseJobPost(false);
              }}
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-blue"
              onClick={() => setCloseJobPost(false)}
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ClostJobPost;
